import type { HTMLAttributes } from "react";

export default function QuizLabelIcon(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props}>
      <svg
        width="19"
        height="19"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 1.5C5.8934 1.5 3.375 4.0184 3.375 7.125C3.375 8.862 4.1623 10.415 5.3995 11.4469C6.14263 12.0667 6.75 12.9074 6.75 13.875H11.25C11.25 12.9074 11.8573 12.0667 12.6005 11.4469C13.8377 10.415 14.625 8.862 14.625 7.125C14.625 4.0184 12.1066 1.5 9 1.5Z"
          stroke="currentColor"
          strokeWidth="1.25"
        />
        <path
          d="M11.25 13.875H6.75V15.375C6.75 15.9963 7.25368 16.5 7.875 16.5H10.125C10.7463 16.5 11.25 15.9963 11.25 15.375V13.875Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 6C7.5 5.24061 8.17155 4.5 9 4.5C9.82845 4.5 10.5 5.11561 10.5 5.875C10.5 6.14873 10.4128 6.40378 10.2623 6.61805C9.81405 7.25665 9 7.86562 9 8.625"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M8.99219 10.5H8.99894"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
